/* eslint-disable */

import request from '@/utils/request'

export function getListRoomLevelApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_level',
    method: 'get',
    params: query
  })
}

export function addRoomLevelApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_level',
    method: 'post',
    data: query
  })
}

export function updateRoomLevelApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_level',
    method: 'put',
    data: query
  })
}
export function deleteRoomLevelApi(query) {
  return request({
    url: '/config-service/v1/hotel/room_level',
    method: 'delete',
    data: query
  })
}

export function getAllRoomLevelApi() {
  return request({
    url: '/config-service/v1/hotel/room_level/all',
    method: 'get'
  })
}
export function exportExcelApi() {
  return request({
    url: '/config-service/v1/hotel/room_level/to-excel',
    method: 'get',
    responseType: 'arraybuffer'
  })
}

export function getTicketTypeApi(data) {
  return request({
    url: '/config-ticket-service/v1/ticket-type',
    method: 'get',
    params: data
  })
}
